// Target size / HQ for Strategic path (a). The composer edits an array of locations;
// the backend stores a single `target_location` string and splits on newlines/semicolons
// (see utils/geography_fit.resolve_target_geos). Commas stay inside a row ("Austin, TX, USA").

export function joinTargetLocations(locations: string[] | undefined): string {
  return (locations ?? [])
    .map((x) => x.trim())
    .filter(Boolean)
    .join('\n');
}

export function splitTargetLocations(raw: string | undefined | null): string[] {
  const arr = (raw ?? '')
    .split(/[\n;]+/)
    .map((x) => x.trim())
    .filter(Boolean);
  return arr.length ? arr : [''];
}
